export const COUNTDOWN_DAYS = 30;
export const COUNTDOWN_DAYS_HIGHLIGHTED = 10;
